// Links into Access Management on a school or trust page. The Edit user panel's Open link uses
// these to take the operator to another organisation with the same user's panel already open.

export const ACCESS_MANAGEMENT_TAB = 'user-management';

// The page for an organisation from the panel's access list, opened on Access Management with
// this user's panel showing.
export function organisationEditLink(organisation, userId) {
  const params = new URLSearchParams({ tab: ACCESS_MANAGEMENT_TAB, editUser: String(userId) });
  return organisation.kind === 'group'
    ? `/group-detail?matId=${encodeURIComponent(organisation.id)}&${params}`
    : `/school-detail?schoolId=${encodeURIComponent(organisation.id)}&${params}`;
}

// The same location with the one-off editUser parameter removed, so closing the panel and then
// refreshing doesn't reopen it.
export function withoutEditUser({ pathname, search }) {
  const params = new URLSearchParams(search);
  if (!params.has('editUser')) return null;
  params.delete('editUser');
  const query = params.toString();
  return query ? `${pathname}?${query}` : pathname;
}
